import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { TreeSelect , Form} from "formik-antd";
import {Col} from "antd";
import "@iso/components/common/form-element/SelectTeam.css"
import {useIntl} from "react-intl";
import {isEqual} from "lodash";
import { clearChildrenOfSelectedParents, toTeamIds } from "@iso/utils/teamHelper";

const SelectTeamForm = ({ name, options, required, disabled, title, styleField, setFieldValue, placeHolder, multiple, values, className, onChange, touched, errors, setFieldTouched }) => {
    const [treeData, setTreeData] = useState([]);
    const { messages } = useIntl();
    const [randomKey, setRandomKey] = useState(Math.random());

    const extractEssentialTreeData = (data) => {
        if (!data) return [];

        return data.map(node => ({
            title: node.teamName ?? (typeof node.title === "string" ? node.title : ""),
            value: node.value,
            children: node.children ? extractEssentialTreeData(node.children) : undefined,
        }));
    };
    useEffect(() => {
        let treeOptions = []
        if (options !== null && options !== undefined) {
            for (let i = 0; i  < options.length; i++) {
                let childOption = []
                const selectedIds = multiple ? toTeamIds(values) : [];
                if (options[i].childTeams !== null && options[i].childTeams !== undefined && options[i].childTeams.length > 0) {
                    for (let childIdx = 0; childIdx < options[i].childTeams.length; childIdx++) {
                        let childDisable = !options[i].active || !options[i].childTeams[childIdx].active
                        if (!childDisable) {
                            if (multiple) {
                                childDisable = selectedIds.includes(Number(options[i].teamId))
                            } else {
                                childDisable = Number(values) === Number(options[i].teamId)
                            }
                        }
                        childOption[childIdx] = {
                            title: options[i].childTeams[childIdx].teamName,
                            value: options[i].childTeams[childIdx].teamId,
                            key: options[i].childTeams[childIdx].teamId,
                            disabled: childDisable,
                            active: !options[i].active || !options[i].childTeams[childIdx].active,
                            teamName: options[i].childTeams[childIdx].teamName,
                        }
                    }
                }
                treeOptions[i] = {
                    title: options[i].teamName,
                    value: options[i].teamId,
                    key: options[i].teamId,
                    disabled: !options[i].active,
                    active: !options[i].active,
                    children: childOption,
                    teamName: options[i].teamName,
                }
            }
        }
        const essentialNew = extractEssentialTreeData(treeOptions);
        const essentialOld = extractEssentialTreeData(treeData);

        if (!isEqual(essentialNew, essentialOld)) {
            setRandomKey(Math.random());
        }
        setTreeData(treeOptions)
    }, [options, values, multiple]);

    const handleChangeTeam = (e) => {
        if (multiple) {
            const nextValues = clearChildrenOfSelectedParents(e, treeData);
            setFieldValue(name, nextValues)
            return nextValues;
        }
        setFieldValue(name, e)
        return e;
    }
    return (
        <Col {...styleField.column} >
            <Form.Item
                {...styleField.label}
                name={name}
                label={title}
                className={className ?? ''}
                required={required}
                help={touched.teams && errors.teams}
                validateStatus={touched.teams && errors.teams ? 'error' : ''}
                rules={[{ required: required, message: messages["form.error.mixed.required"].replace("${path}", messages["page.storeAddEditEmail.executedTeam"]) }]}
            >
                <TreeSelect
                    key={randomKey}
                    name={name}
                    treeData={treeData}
                    placeholder={placeHolder}
                    disabled={disabled}
                    multiple={multiple}
                    treeCheckable={multiple}
                    treeCheckStrictly={multiple}
                    showSearch
                    showArrow
                    allowClear
                    onChange={(e, node, extra) => {
                        const nextValues = handleChangeTeam(e)
                        setFieldTouched(name, true);
                        onChange && onChange(nextValues, node, extra)
                    }}
                    filterTreeNode={(inputValue, treeNode) =>
                        String(treeNode.teamName ?? treeNode.title ?? '')
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                    }
                />
            </Form.Item>
        </Col>
    );
};

SelectTeamForm.propTypes = {
    name: PropTypes.string,
    options: PropTypes.any,
    title: PropTypes.string,
    styleField: PropTypes.any,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    setFieldValue: PropTypes.any,
    placeHolder: PropTypes.any,
    values: PropTypes.any,
};

export default SelectTeamForm;
